import { Box, Modal, Pagination } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllcontactUs } from '../Redux/Slice/contactUs.slice';
import { FaEye, FaSearch, FaTimes, FaUserAlt, FaEnvelope, FaCommentAlt } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

export default function Contact() {
    const [searchValue, setSearchValue] = useState('');
    const dispatch = useDispatch();
    const contact = useSelector((state) => state.contactUs.contactUs);
    const [viewOpen, setViewOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        dispatch(getAllcontactUs())
    }, [dispatch])

    const filteredData = contact.filter(data =>
        data?.firstName?.toLowerCase().includes(searchValue.toLowerCase()) ||
        data?.lastName?.toLowerCase().includes(searchValue.toLowerCase()) ||
        data?.email?.toLowerCase().includes(searchValue.toLowerCase()) ||
        data?.message?.toLowerCase().includes(searchValue.toLowerCase())
    );

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const currentItems = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handleview = (user) => {
        setSelectedUser(user);
        setViewOpen(true);
    };

    const handleViewClose = () => {
        setViewOpen(false);
        setSelectedUser(null);
    };

    return (
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                    <h1 className="text-3xl font-bold text-white tracking-tight">Inquiries</h1>
                    <p className="text-gray-400">Review and respond to user messages.</p>
                </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-3xl overflow-hidden backdrop-blur-sm">
                <div className="p-6 border-b border-white/5 flex flex-col sm:flex-row gap-4 items-center justify-between">
                    <div className="relative w-full sm:w-80 group">
                        <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 group-focus-within:text-primary transition-colors" />
                        <input
                            type="text"
                            placeholder="Search messages, names, emails..."
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            className="w-full bg-white/5 border border-white/10 rounded-xl pl-12 pr-4 py-2.5 text-sm text-white focus:border-primary/50 outline-none transition-all"
                        />
                    </div>
                    <p className="text-xs font-bold text-gray-500 uppercase tracking-widest">
                        Total Inquiries: {filteredData.length}
                    </p>
                </div>

                <div className="overflow-x-auto no-scrollbar">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-white/[0.02]">
                                <th className="px-6 py-3 text-xs font-bold text-gray-500 uppercase tracking-widest">Sender</th>
                                <th className="px-6 py-3 text-xs font-bold text-gray-500 uppercase tracking-widest">Contact Email</th>
                                <th className="px-6 py-3 text-xs font-bold text-gray-500 uppercase tracking-widest">Message Preview</th>
                                <th className="px-6 py-3 text-xs font-bold text-gray-500 uppercase tracking-widest text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-white/5">
                            {currentItems.map((user, index) => (
                                <tr key={user._id} className="hover:bg-white/[0.02] transition-colors group">
                                    <td className="px-6 py-4">
                                        <div className="flex items-center gap-3">
                                            <div className="w-9 h-9 rounded-xl bg-white/5 flex items-center justify-center text-gray-400 group-hover:text-primary transition-colors border border-white/10">
                                                <FaUserAlt size={14} />
                                            </div>
                                            <span className="text-sm font-bold text-white whitespace-nowrap">{user.firstName} {user.lastName}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="flex items-center gap-2 text-gray-400">
                                            <FaEnvelope size={12} className="opacity-50" />
                                            <span className="text-xs">{user.email}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 max-w-md">
                                        <p className="text-xs text-gray-500 line-clamp-1 italic">"{user.message}"</p>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="flex justify-end">
                                            <button 
                                                onClick={() => handleview(user)}
                                                className="p-2.5 rounded-xl bg-primary/10 text-primary hover:bg-primary hover:text-white transition-all border border-primary/20 shadow-lg shadow-primary/10"
                                            >
                                                <FaEye size={16} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                             {currentItems.length === 0 && (
                                <tr>
                                    <td colSpan="4" className="px-8 py-12 text-center text-gray-500 italic">No inquiries found matching your search.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {totalPages > 1 && (
                    <div className="p-6 border-t border-white/5 flex justify-end">
                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={(_, page) => setCurrentPage(page)}
                            sx={{
                                "& .MuiPaginationItem-root": { color: "#9ca3af", borderColor: "rgba(255,255,255,0.1)", borderRadius: "12px" },
                                "& .Mui-selected": { backgroundColor: "rgba(98,99,237,0.2) !important", color: "#6263ED !important", borderColor: "rgba(98,99,237,0.5) !important" }
                            }}
                        />
                    </div>
                )}
            </div>

            <Modal open={viewOpen} onClose={handleViewClose} className="flex items-center justify-center p-4">
                <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="bg-[#141414] border border-white/10 rounded-[40px] w-full max-w-lg shadow-2xl outline-none overflow-hidden">
                    <div className="p-8 border-b border-white/5 flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 rounded-2xl bg-primary/10 text-primary flex items-center justify-center border border-primary/20 shadow-lg shadow-primary/5">
                                <FaCommentAlt size={20} />
                            </div>
                            <div>
                                <h2 className="text-2xl font-bold text-white">Inquiry Details</h2>
                                <p className="text-[10px] text-gray-500 font-black uppercase tracking-widest">Internal Review</p>
                            </div>
                        </div>
                        <button onClick={handleViewClose} className="p-3 rounded-2xl bg-white/5 text-gray-400 hover:text-white transition-all border border-white/10">
                            <FaTimes size={20} />
                        </button>
                    </div>

                    {selectedUser && (
                        <div className="p-8 space-y-8">
                            <div className="grid grid-cols-2 gap-6">
                                <div className="space-y-1.5">
                                    <p className="text-[10px] font-black uppercase text-gray-500 tracking-[0.2em] ml-1">First Name</p>
                                    <div className="bg-white/5 border border-white/10 px-5 py-3 rounded-2xl text-white font-bold">{selectedUser.firstName}</div>
                                </div>
                                <div className="space-y-1.5">
                                    <p className="text-[10px] font-black uppercase text-gray-500 tracking-[0.2em] ml-1">Last Name</p>
                                    <div className="bg-white/5 border border-white/10 px-5 py-3 rounded-2xl text-white font-bold">{selectedUser.lastName}</div>
                                </div>
                            </div>
                            
                            <div className="space-y-1.5">
                                <p className="text-[10px] font-black uppercase text-gray-500 tracking-[0.2em] ml-1">Direct Email</p>
                                <div className="bg-white/5 border border-white/10 px-5 py-3 rounded-2xl text-primary font-bold">{selectedUser.email}</div>
                            </div>

                            <div className="space-y-1.5">
                                <p className="text-[10px] font-black uppercase text-gray-500 tracking-[0.2em] ml-1">Inquiry Narrative</p>
                                <div className="bg-white/[0.02] border border-white/5 p-6 rounded-[32px] text-gray-300 leading-relaxed text-sm italic shadow-inner">
                                    "{selectedUser.message}"
                                </div>
                            </div>

                            <button onClick={handleViewClose} className="w-full py-5 rounded-[24px] bg-gradient-primary text-white font-black uppercase tracking-widest shadow-lg shadow-primary/20 hover:shadow-primary/40 transition-all">
                                Acknowledge & Close
                            </button>
                        </div>
                    )}
                </motion.div>
            </Modal>
        </motion.div>
    )
}
